import React, { useEffect, useState } from 'react'
import { BodyDrawer } from './styles'
import { HeaderDrawer } from '../../CustomUi/headerGaveta'
import { Render } from '../../CustomUi/render'
import Carregando from '../../CustomUi/loading'
import Input from '../../CustomUi/input'
import { Select } from '../../CustomUi/Select'
import ButtonCustom from '../../ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBug, faBugs, faList, faMicroscope, faPlus } from '@fortawesome/free-solid-svg-icons'
import { Box } from '../../CustomUi/box'
import { HeaderTable } from '../../CustomUi/table/headerTable'
import { BodyTable } from '../../CustomUi/table/bodyTable'
import { RowTable } from '../../CustomUi/table/rowTable'
import { RowItem } from '../../CustomUi/table/rowItem'
import { DeleteButton } from '../../CustomUi/deleteButton'
import { Empty } from 'antd'
import { destroyAlert, loadingAlert } from '../../../utils/alert'
import { AxiosResponse } from 'axios'
import { getMoniEspecie, TypeMoniEspecie } from '../../../services/monitoramento/especie'

interface PropsFormCatalogoForm {
  loadingForm: boolean
  update: number
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  nomeCientifico: string
  setNomeCientifico: React.Dispatch<React.SetStateAction<string>>
  categoria: string
  setCategoria: React.Dispatch<React.SetStateAction<string>>
  categoriaId: number
  setCategoriaId: React.Dispatch<React.SetStateAction<number>>
  variacao: string
  setVariacao: React.Dispatch<React.SetStateAction<string>>
  inserirVariacao: Function
  deletarVariacao: Function
  dataVariacao: any[]
}

export const FormCatalogoForm: React.FC<PropsFormCatalogoForm> = ({
  loadingForm,
  update,
  nome,
  setNome,
  nomeCientifico,
  setNomeCientifico,
  categoria,
  setCategoria,
  categoriaId,
  setCategoriaId,
  variacao,
  setVariacao,
  inserirVariacao,
  deletarVariacao,
  dataVariacao,
}) => {
  const [openCategoria, setOpenCategoria] = useState(false)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)
  const dataCategoria = [
    { nome: 'Praga', cod: 1 },
    { nome: 'Planta Daninha', cod: 2 },
    { nome: 'Doença', cod: 3 },
  ]

  return (
    <>
      <Render condition={loadingForm}>
        <Carregando
          animation
          justifyContent='center'
          height={'100%'}
          legenda='Carregando informações...'
        />
      </Render>
      <HeaderDrawer>
        {update > 0 ? 'Atualizar catálogo de pragas' : 'Cadastrar catálogo de pragas'}
      </HeaderDrawer>
      <Render condition={loadingForm === false}>
        <BodyDrawer>
          <Input
            label='Nome'
            placeholder='Digite o nome'
            value={nome}
            onChange={setNome}
            icon={faBug}
            obrigatorio
          />
          <Input
            label='Nome científico'
            placeholder='Digite o nome científico '
            icon={faMicroscope}
            value={nomeCientifico}
            onChange={setNomeCientifico}
          />
          <Select
            label='Categoria'
            placeholder='Selecione a categoria da praga'
            value={categoria}
            onChange={setCategoria}
            onChangeID={setCategoriaId}
            open={openCategoria}
            trigger={setOpenCategoria}
            items={dataCategoria}
            descricaoItem={'nome'}
            idItem={'cod'}
            icon={faList}
            obrigatorio
          />
          <Box>
            <div className='campo__dois__inputs'>
              <Input
                label='Variação'
                placeholder='Digite o variação'
                icon={faBugs}
                value={variacao}
                onChange={setVariacao}
                obrigatorio
              />
              <ButtonCustom
                style={{ marginTop: '10px' }}
                onClick={inserirVariacao}
                icon={<FontAwesomeIcon icon={faPlus} />}
              />
            </div>
            <HeaderTable
              itens={[
                { valor: 'Nome', width: 'calc(100% - 80px)' },
                { valor: 'Ações', width: '80px' },
              ]}
            />

            <BodyTable
              style={{
                height: (dataVariacao ?? []).length < 8 && 'calc(100vh - 550px)',
                position: 'relative',
                overflowX: 'hidden',
                overflowY: 'scroll',
                marginTop: -10,
              }}
            >
              <Render condition={dataVariacao.length > 0}>
                {(dataVariacao ?? []).map(({ cod, cod_temp, nome }) => {
                  return (
                    <RowTable key={cod} onDoubleClick={() => {}}>
                      <RowItem fontSize={13} width={'calc(100% - 74px)'}>
                        {nome}
                      </RowItem>

                      <RowItem width={'74px'} gap={10}>
                        <DeleteButton
                          open={confirmar_exclusao && id_item_atual === (cod ?? cod_temp)}
                          trigger={setConfirmar_exclusao}
                          onTrigger={() => {
                            setId_item_atual(cod ?? cod_temp)
                            setNome_item_atual(`${nome} `)
                          }}
                          loading={fake_loading}
                          message={`o item ${`${nome} `} será excluido!`}
                          deleteds={[`${nome} `]}
                          onDelete={() => {
                            deletarVariacao(cod ?? cod_temp)
                          }}
                          disabled={fake_loading}
                          typeButtonTrigger='secondary'
                        />
                      </RowItem>
                    </RowTable>
                  )
                })}
              </Render>

              <Render condition={dataVariacao.length === 0}>
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={<> Nenhum registro disponível!</>}
                />
              </Render>

              {/* <Render condition={loadingAnalises}>
                <Carregando
                  animation
                  legenda='Carregando análises...'
                  justifyContent='center'
                  height={'100%'}
                  size='default'
                />
              </Render> */}
            </BodyTable>
          </Box>
        </BodyDrawer>
      </Render>
    </>
  )
}
